import { getId } from "helpers/functions";
import {
  GET_SECTIONS,
  GET_SECTIONS_FAILURE,
  GET_SECTIONS_SUCCESS,
  ADD_SECTION,
  ADD_SECTION_SUCCESS,
  ADD_SECTION_FAILURE,
  DELETE_SECTION,
  DELETE_SECTION_SUCCESS,
  DELETE_SECTION_FAILURE,
  GET_SINGLE_SECTION,
  GET_SINGLE_SECTION_FAILURE,
  GET_SINGLE_SECTION_SUCCESS,
  EDIT_SECTION,
  EDIT_SECTION_SUCCESS,
  EDIT_SECTION_FAILURE,
} from "./actionTypes";

const initialState = {
  sections: [],
  loading: false,
  error: "",
  singleSection: {},
};

const stores = (state = initialState, action) => {
  switch (action.type) {
    case GET_SECTIONS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_SECTIONS_SUCCESS:
      state = {
        ...state,
        loading: false,
        sections: action.payload.sections,
      };
      break;
    case GET_SECTIONS_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case GET_SINGLE_SECTION:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_SINGLE_SECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        singleSection: action.payload.section,
      };
      break;
    case GET_SINGLE_SECTION_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case ADD_SECTION:
      state = {
        ...state,
        loading: true,
      };
      break;
    case ADD_SECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        sections: action.payload.sections,
      };
      break;
    case ADD_SECTION_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case EDIT_SECTION:
      state = {
        ...state,
        loading: true,
      };
      break;
    case EDIT_SECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case EDIT_SECTION_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case DELETE_SECTION:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DELETE_SECTION_SUCCESS:
      const usersAfterDeleteing = (state?.sections || [])?.filter(
        (section) => getId(section) !== action.payload
      );

      state = {
        ...state,
        loading: false,
        sections: usersAfterDeleteing,
      };
      break;
    case DELETE_SECTION_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default stores;
